import axios from "axios";
import { PATH } from "../redux/utils";
import store from "../store";
import { sessionManager } from "../redux/sessionManager";
import { USER_LOGOUT } from "../redux/actions/login/types";

export { USER_LOGOUT };

const SESSION_KEYS = ["token", "email", "role", "last_login", "userAvatar"];

function safeRemove(key) {
  try {
    localStorage.removeItem(key);
  } catch (_) {}
}

export async function performLogout({ redirectTo } = {}) {
  const token = localStorage.getItem("token");

  try {
    await axios.post(
      `${PATH}/auth/logout`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        _retryAuth: true,
        timeout: 5000,
      }
    );
  } catch (_) {
    /* swallow */
  }

  SESSION_KEYS.forEach(safeRemove);

  try {
    sessionStorage.clear();
  } catch (_) {}

  try {
    sessionManager.onAuthFailure();
  } catch (_) {}

  try {
    store.dispatch({ type: USER_LOGOUT });
  } catch (_) {}

  const target = redirectTo || "/login";
  try {
    window.history.replaceState(null, "", target);
  } catch (_) {}
  window.location.replace(target);
}
